module.exports = __webpack_public_path__ + "img/banner1.2d1643f6.jpg";